<app-input
    [control]="control"
    [marginBottom]="marginBottom"
    [label]="label !== undefined ? label : ('forms.labels.birthDate' | translateSafe)"
    [placeholder]="placeholder !== undefined ? placeholder : ('forms.placeholders.birthDate' | translateSafe)"
    autocomplete="bday"
    (blur)="inputBlur.emit()"
></app-input>
